module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"crenshaw-stories\"-in-torrance-california-66509c81173798ebf1ec97447a4c898c.png";